<div class="min-h-screen flex flex-col justify-center items-center bg-[url('/assets/images/auth-bg.jpg')] bg-center bg-cover p-10 md:p-20">
  <div class="text-center mb-10">
    <img src="assets/images/logo.svg" alt="Emsys" class="h-10">
  </div>

  <div class="flex flex-nowrap shadow-xl shadow-slate-100/50 w-full max-w-4xl">
    <div class="bg-sky-500 text-white w-[28rem] p-6 md:p-10 rounded-l-xl">
      <vm-teleport name="greet"></vm-teleport>
    </div>

    <div class="bg-white flex-1 p-6 md:p-10 rounded-r-xl">
      <ng-content></ng-content>
    </div>
  </div>
</div>
